// Register.js
import React, { useState } from 'react';
import {
    Box,
    Paper,
    Typography,
    TextField,
    Button,
    Divider,
} from '@mui/material';
import authService from '../Auth/AuthService';
import { useNavigate } from 'react-router-dom';

const AdminRegister = () => {
    const [formData, setFormData] = useState({
        email: '',
        mobile: '',
        password: '',
        roleType: 'SUPERADMIN',
        loginType: 'OWNER',
        isActive: true,
        isMobileVerify: true,
        isEmailVerify: true,
    });
    const navigate = useNavigate();
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Register Data:', formData);
        try {
            const url = authService.pathUrl('POST', '/auth/register')
            const response = await authService.registerLogin(url, formData);
            console.log('Success:', response.data);
            navigate("/");
            window.location.reload();
        } catch (error) {
            console.error('Error:', error);
        }
    };

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="90vh"
            bgcolor="#f4f6f8"
        >
            <Paper elevation={4} sx={{ p: 4, width: '100%', maxWidth: 400, borderRadius: 5, }}>
                <Typography variant="h5" align="center" fontWeight={600} gutterBottom>
                    Admin Registration
                </Typography>
                <Divider sx={{ mb: 4 }} />
                <form onSubmit={handleSubmit}>
                    <TextField
                        label="Email"
                        name="email"
                        fullWidth
                        margin="normal"
                        value={formData.email}
                        onChange={handleChange}
                    />
                    <TextField
                        label="Mobile"
                        name="mobile"
                        fullWidth
                        margin="normal"
                        value={formData.mobile}
                        onChange={handleChange}
                    />
                    <TextField
                        label="Password"
                        name="password"
                        type="password"
                        fullWidth
                        margin="normal"
                        value={formData.password}
                        onChange={handleChange}
                    />
                    {/* <TextField
                        select
                        label="Register Type"
                        name="loginType"
                        fullWidth
                        margin="normal"
                        value={formData.loginType}
                        onChange={handleChange}
                    >
                        {loginTypes.map((type) => (
                            <MenuItem key={type} value={type}>
                                {type}
                            </MenuItem>
                        ))}
                    </TextField> */}
                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        sx={{
                            mt: 3,
                            bgcolor: '#1b1914',
                            fontWeight: 'bold',
                            fontSize: '16px',
                            paddingY: 1,
                            borderRadius: 6,
                            '&:hover': {
                                backgroundColor: '#332a14ff',
                            },
                        }}
                    >
                        Register
                    </Button>
                </form>
                <Typography variant="body2" mt={3} align="center" >
                    Aready have an account? <a href="login" style={{ color: '#2575fc' }}>Login</a>
                </Typography>
            </Paper>
        </Box>
    );
};

export default AdminRegister;
